import { Icon } from '@chakra-ui/react';

export const ArrowDropRight = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <g id="arrow_drop_right">
      <path
        id="Vector"
        d="M11.4136 15.2934L14.0036 12.7034C14.3936 12.3134 14.3936 11.6834 14.0036 11.2934L11.4136 8.70337C10.7836 8.07337 9.70361 8.52337 9.70361 9.41337L9.70361 14.5934C9.70361 15.4834 10.7836 15.9234 11.4136 15.2934Z"
        fill="currentColor"
      />
    </g>
  </Icon>
);
